import React from 'react';
import { Box, Center } from '@chakra-ui/react';
import { motion } from 'framer-motion';

const MotionCenter = motion(Center);

export const Loading = () => {
  return (
    <MotionCenter
      key="loading-messages-spin"
      mt="8px"
      h="44px"
      w="44px"
      borderRadius="12px"
      backgroundColor="scheme.backgroundSecondary"
      exit={{ height: 0, opacity: 0, width: 0, marginTop: 0 }}
    >
      <Box
        color="scheme.borderSecondary"
        as="svg"
        width="68%"
        height="68%"
        viewBox="0 0 30 30"
        fill="none"
        preserveAspectRatio="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="15"
          cy="15"
          r="14"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-dasharray="7 7"
        >
          <animateTransform
            attributeName="transform"
            attributeType="XML"
            type="rotate"
            from="0 15 15"
            to="360 15 15"
            dur="1.3s"
            repeatCount="indefinite"
          />
        </circle>
      </Box>
    </MotionCenter>
  );
};
